import { useScrollAnimation } from '@/hooks/useScrollAnimation';

export default function ContactEn() {
  const headerAnim = useScrollAnimation();
  const cardsAnim = useScrollAnimation({ rootMargin: '0px 0px -40px 0px' });
  const ctaAnim = useScrollAnimation({ rootMargin: '0px 0px -40px 0px' });

  const contactCards = [
    {
      icon: 'ri-mail-send-line',
      label: 'Email Inquiry',
      value: 'info@fixcope.com',
      description: 'Send us your questions about products, partnerships, or consulting.',
      action: 'mailto:info@fixcope.com',
      actionLabel: 'Send Email',
    },
    {
      icon: 'ri-phone-line',
      label: 'Phone Inquiry',
      value: '+82-2-2264-2563',
      description: 'Mon–Fri 09:00 – 18:00 KST (Lunch 12:00 – 13:00)',
      action: 'tel:+82222642563',
      actionLabel: 'Call Now',
    },
    {
      icon: 'ri-map-pin-2-line',
      label: 'Visit Us',
      value: 'Songpa-gu, Seoul\nSouth Korea',
      description: 'In-person consultations are available by appointment only.',
      action: 'https://maps.google.com/?q=Songpa-gu+Seoul+South+Korea',
      actionLabel: 'View Map',
    },
  ];

  const inquiryAreas = [
    { icon: 'ri-heart-pulse-line', label: 'Medical Equipment Supply' },
    { icon: 'ri-eye-line', label: 'Vision Inspection Platform' },
    { icon: 'ri-camera-3-line', label: 'Micro Camera Technology' },
    { icon: 'ri-global-line', label: 'Global Expansion Consulting' },
  ];

  return (
    <section id="contact" className="py-16 sm:py-20 md:py-28 bg-[#FFFBF5]">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div
          ref={headerAnim.ref}
          className={`text-center mb-16 transition-all duration-700 ${headerAnim.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          <div className="inline-flex items-center gap-2 mb-5">
            <span className="w-8 h-[2px] bg-[#E8650A]"></span>
            <span className="text-xs font-semibold text-[#E8650A] uppercase tracking-widest whitespace-nowrap">Contact Us</span>
            <span className="w-8 h-[2px] bg-[#E8650A]"></span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A2530] mb-4">Get in Touch</h2>
          <p className="text-gray-500 text-[14px] sm:text-[15px] max-w-xl mx-auto leading-relaxed">
            For partnerships, product inquiries, or consulting requests,<br className="hidden sm:block" />
            please contact us directly through the channels below.
          </p>
        </div>

        {/* Contact Cards */}
        <div
          ref={cardsAnim.ref}
          className={`grid grid-cols-1 md:grid-cols-3 gap-6 mb-12 transition-all duration-700 ${cardsAnim.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          {contactCards.map((card, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-8 border border-gray-100 flex flex-col items-start group hover:border-[#E8650A]/30 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#E8650A]/10 mb-5 group-hover:bg-[#E8650A]/20 transition-colors">
                <i className={`${card.icon} text-xl text-[#E8650A]`}></i>
              </div>
              <div className="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-2 whitespace-nowrap">{card.label}</div>
              <div className="text-lg font-bold text-[#1A2530] mb-2 whitespace-pre-line leading-snug">{card.value}</div>
              <p className="text-[13px] text-gray-500 leading-relaxed mb-6 flex-1">{card.description}</p>
              <a
                href={card.action}
                target={card.action.startsWith('http') ? '_blank' : undefined}
                rel={card.action.startsWith('http') ? 'noopener noreferrer nofollow' : undefined}
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-[#1A2530] text-white text-sm font-medium hover:bg-[#E8650A] transition-colors whitespace-nowrap cursor-pointer"
              >
                {card.actionLabel}
                <i className="ri-arrow-right-line text-sm"></i>
              </a>
            </div>
          ))}
        </div>

        {/* Bottom: Inquiry Areas + CTA */}
        <div
          ref={ctaAnim.ref}
          className={`bg-[#1A2530] rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-start md:items-center gap-8 transition-all duration-700 ${ctaAnim.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          <div className="flex-1 w-full">
            <div className="text-xs font-semibold text-[#E8650A] uppercase tracking-widest mb-4 whitespace-nowrap">Inquiry Areas</div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              {inquiryAreas.map((item, i) => (
                <div key={i} className="flex items-center gap-3 bg-white/10 rounded-xl px-4 py-3">
                  <div className="w-6 h-6 flex items-center justify-center shrink-0">
                    <i className={`${item.icon} text-base text-[#FF8C3A]`}></i>
                  </div>
                  <span className="text-[13px] text-white leading-snug">{item.label}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="shrink-0 w-full md:w-auto text-left md:text-right border-t border-white/10 md:border-t-0 pt-6 md:pt-0">
            <p className="text-white/70 text-sm mb-1">For a quick response, call us</p>
            <a
              href="tel:+82222642563"
              className="text-2xl font-bold text-white hover:text-[#FF8C3A] transition-colors whitespace-nowrap cursor-pointer"
            >
              +82-2-2264-2563
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}
